import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import System from "../../../domains/Systems/System";
import SystemComponentRange from "../../../domains/Systems/SystemComponentRange";
import Dictionary from "../../../domains/Dictionary";
import Site from "../../../domains/Site";
import SystemSpecifications from "../../../domains/Systems/SystemSpecifications";

import { SLICE_NAME } from "./types";

export interface SystemsState {
  systems: Array<System>
  areSystemsLoading: boolean
  hasErrorLoadingSystems: boolean
  systemRanges: Dictionary<SystemComponentRange>
  areSystemRangesLoading: boolean
  hasErrorLoadingSystemRanges: boolean
  sites: Array<Site>
  systemsSpecifications: SystemSpecifications
  areSystemSpecificationsLoading: boolean
  hasErrorLoadingSystemSpecifications: boolean
}

export const initialState: SystemsState = {
  systems: [],
  areSystemsLoading: false,
  hasErrorLoadingSystems: false,
  areSystemRangesLoading: false,
  hasErrorLoadingSystemRanges: false,
  systemRanges: {},
  sites: [],
  systemsSpecifications: {},
  areSystemSpecificationsLoading: false,
  hasErrorLoadingSystemSpecifications: false
};


export const systemsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getSystems: state => {
      state.areSystemsLoading = true;
    },
    getSystemsSuccess: (state, action: PayloadAction<Array<System>>) => {
      state.systems = action.payload;
      state.areSystemsLoading = false;
    },
    getSystemsError: state => {
      state.areSystemsLoading = false;
      state.hasErrorLoadingSystems = true;
    },
    getSystemsComponentsRange: state => {
      state.areSystemRangesLoading = true;
    },
    getSystemsComponentsRangeSuccess: (
      state,
      action: PayloadAction<Dictionary<SystemComponentRange>>,
    ) => {
      state.systemRanges = action.payload;
      state.areSystemRangesLoading = false;
    },
    getSystemsComponentsRangeError: state => {
      state.areSystemRangesLoading = false;
      state.hasErrorLoadingSystemRanges = true;
    },
    setSites: 
      (state, action: PayloadAction<Array<Site>>) => {
        state.sites = [...action.payload];
      },
    getSystemSpecifications: state => {
      state.areSystemSpecificationsLoading = true;
    },
    getSystemSpecificationsStateSuccess: (state, action: PayloadAction<SystemSpecifications>) => {
      state.areSystemSpecificationsLoading = false;
      state.systemsSpecifications = action.payload;
    },
    getSystemSpecificationsError: state => {
      state.areSystemSpecificationsLoading = false;
      state.hasErrorLoadingSystemSpecifications = true;
    }
    
  },
});

export const {
  getSystems,
  getSystemsSuccess,
  getSystemsError,
  getSystemsComponentsRange,
  getSystemsComponentsRangeError,
  getSystemsComponentsRangeSuccess,
  setSites,
  getSystemSpecifications,
  getSystemSpecificationsStateSuccess,
  getSystemSpecificationsError,
} = systemsSlice.actions;

export default systemsSlice.reducer;
